// extracted by mini-css-extract-plugin
module.exports = {"content":"Product_content__JIeoJ","submitBtn":"Product_submitBtn__39vVd"};